export default __webpack_public_path__ + "files/e68c2e08344e8bfd792fba89b4dfcc0f.svg";